export default __webpack_public_path__ + "4cae06f56b73bef8fa597d443ae30ae1.png";